import { format } from 'date-fns';

export const parseISODateFormat = (date: string, withTime: boolean = false): string => {
  const dateFormat = withTime ? 'yyyy-MM-dd hh:mm:ss a' : 'yyyy-MM-dd';
  return date ? format(new Date(date), dateFormat) : ``;
};
